import Angular from "angular";
import Controller from "./chart-resource-workload.controller";
import Template from "./chart-resource-workload.html";

export default Angular.module('chart-resource-workload', [])
    .component('chartResourceWorkload', {
        template: Template,
        controller: Controller,
        bindings: {
            workloads: '<'
        },
    })



// WEBPACK FOOTER //
// ./src/modules/main/components/chart-resource-workload/chart-resource-workload.js